import { Box, Grid, GridItem, Heading, Text, VStack } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import { SettingsNav } from '@/features/settings/components/SettingsNav'

export function SettingsLayout() {
  return (
    <Box w="full" maxW="full">
      <VStack align="stretch" gap={6} w="full">
        {/* Header */}
        <VStack align="start" gap={2} w="full">
          <Heading as="h1" fontSize="3xl" fontWeight="bold">
            Paramètres
          </Heading>
          <Text color="gray.600">
            Gérez votre compte, votre équipe et vos préférences
          </Text>
        </VStack>

        {/* Content Grid */}
        <Grid
          templateColumns={{ base: '1fr', md: '280px 1fr' }}
          gap={6}
          alignItems="start"
          w="full"
        >
          {/* Sidebar Navigation */}
          <GridItem display={{ base: 'none', md: 'block' }}>
            <Box
              position="sticky"
              top="24px"
              p={4}
              bg="white"
              borderRadius="lg"
              border="1px solid"
              borderColor="gray.200"
            >
              <SettingsNav />
            </Box>
          </GridItem>

          {/* Main Content */}
          <GridItem w="full">
            <Outlet />
          </GridItem>
        </Grid>
      </VStack>
    </Box>
  )
}
